import React from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import CodeBlock from 'components/CodeBlock'
import './styles.css'

const flattenElem = (text, child) => {
  return typeof child === 'string'
    ? text + child
    : React.Children.toArray(child.props.children).reduce(flattenElem, text)
}

const MarkdownText = ({ contentMD }) => {
  /**
   * HeadingRenderer is a custom renderer
   * It parses the heading and attaches an id to it to be used as an anchor
   */
  const HeadingRenderer = (props) => {
    const { children, level } = props
    const childrenArr = React.Children.toArray(children)
    const text = childrenArr.reduce(flattenElem, '')
    const slug = text.toLowerCase().replace(/[ |.]/g, '-')
    return React.createElement(`h${level}`, { id: slug }, childrenArr)
  }

  return (
    <div className="markdown-body">
      <Markdown
        components={{
          code: CodeBlock,
          h1: HeadingRenderer,
          h2: HeadingRenderer,
          h3: HeadingRenderer,
          h4: HeadingRenderer,
          h5: HeadingRenderer,
          h6: HeadingRenderer,
        }}
        skipHtml={true}
        escapeHtml={false}
        remarkPlugins={[remarkGfm]}
      >
        {contentMD}
      </Markdown>
    </div>
  )
}

export default MarkdownText
